export const texts = {
  home: "Powerbet",
  back: "Volver",
  register: "REGISTRO",
  login: "INGRESAR"
} as const
